import styled from 'styled-components';

export const ProductDisplaySection = styled.div`
  max-width: 85%;
  margin: 10px auto 0;
  display: flex;
  padding-top: 10px;
  align-items: flex-start;
  @media (max-width: 720px) {
    flex-direction: column-reverse;
    max-width: 90%;
  }
  justify-content: space-between;
`;
export const DisplayColumn = styled.div`
  flex-basis: 50%;
  align-self: ${(props) => (props.order === 2 ? 'baseline' : 'unset')};
  @media (max-width: 720px) {
    padding-top: ${(props) => (props.order === 1 ? '30px' : '0')};
  }
  a {
    &.lowOpacity {
      opacity: 0.4;
    }
  }
`;

export const DisplayImgContainer = styled.div`
  max-width: 38vw;
  position: relative;
  height: 38vw;
  margin-left: 10%;
  @media (min-width: 768px) {
    cursor: pointer;
  }
  @media (max-width: 720px) {
    height: 90vw;
    margin: 0;
    width: 90vw;
    max-width: 100%;
  }
  &.lowOpacity {
    opacity: 0.4;
  }
`;
export const DetailSection = styled.div`
  h2 {
    font-size: clamp(20px, 3vw, 36px);
    margin-bottom: 30px;
    opacity: 0.87;
    @media (max-width: 720px) {
      margin-bottom: 20px;
    }
  }
  p {
    font-size: clamp(14px, 2vw, 18px);
    opacity: 0.9;
    margin-bottom: 20px;
  }
  span {
    font-style: italic;
    font-size: 12px;
    opacity: 0.9;
  }
`;
export const FeatureList = styled.div`
  padding-top: 10px;
`;
export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  margin: 6px 0;
  img {
    width: 28px;
  }
  p {
    padding-left: 6px;
    font-size: clamp(12px, 2vw, 16px);
  }
`;
export const KnowMoreBtn = styled.button`
  width: 160px;
  height: 40px;
  border-radius: 32px;
  background-color: #ef4e5e;
  border: none;
  color: white;
  overflow: hidden;
  position: relative;
  font-family: Montserrat;
  margin: 10px 0 20px;
  @media (min-width: 768px) {
    cursor: pointer;
  }
  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
export const ProductInfoSection = styled.div`
  h3 {
    font-size: clamp(16px, 2vw, 22px);
    opacity: 0.9;
  }
`;
export const ProductsList = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 20px;
  a {
    &.lowOpacity {
      opacity: 0.4;
    }
  }
`;
export const ProdCard = styled.div`
  @media (min-width: 768px) {
    cursor: pointer;
  }
  cursor: default;
  flex-basis: 30%;
  @media (max-width: 768px) {
    flex-basis: 40%;
  }
  img {
    width: 80%;
  }
  p {
    font-size: clamp(11px, 2vw, 18px);
    font-weight: 500;
    max-width: 150px;
    padding-top: 10px;
  }
  &.lowOpacity {
    opacity: 0.4;
  }
`;
